import { SectionLabel } from "../SectionLabel";
import { AdvantageCard } from "./AdvantageCard";

const advantages = [
  {
    icon: "/images/money_15512574 1.svg",
    title: "Keep 100% of Revenue.",
    description: "Stop losing margins. Customers pay you directly—we don’t take a cut.",
    tinted: true,
  },
  {
    icon: "/images/Layer_x0020_1.svg",
    title: "Frictionless Redemption.",
    description: "No new hardware or staff training required. Customers redeem seamlessly on their own phones.",
  },
  {
    icon: "/images/Group 2085663690.svg",
    title: "Real-Time ROI",
    description: "Track views, follows, and redemptions instantly. Know exactly what's driving your growth.",
  },
  {
    icon: "/images/Group 2085663691.svg",
    title: "AI-Powered Marketing",
    description: "Don't have time to write? Our AI generates perfect coupon headlines and terms in seconds.",
  },
];

export const OurAdvantageSection = () => {
  return (
    <section className="w-full px-[16px] sm:px-6 lg:px-[80px] pt-16 lg:pt-[140px]">
      <div className="mx-auto w-full max-w-[1620px]">
        <SectionLabel align="left">Our Advantage</SectionLabel>

        <h2 className="mt-6 lg:mt-12 max-w-[760px] text-[#171717] font-normal leading-[1.2] tracking-[-1.5px] text-[32px] sm:text-[44px] lg:text-[64px]">
          Powerful Growth,
          <br />
          Zero Friction
        </h2>

        <p className="mt-[16px] lg:mt-8 max-w-[560px] text-[#2A2A2A] text-[15px] lg:text-[20px] leading-[1.4]">
          Enterprise-grade marketing tools designed for busy local owners. No complex tech, no staff headaches.
        </p>

        <div className="mt-10 lg:mt-14 grid grid-cols-1 lg:grid-cols-[42%_1fr] gap-[16px] lg:gap-5">
          <img
            src="/images/Webp/Rectangle 34625690.webp"
            alt="Customer redeeming a coupon on their phone at checkout"
            className="w-full h-[320px] sm:h-[420px] lg:h-full lg:min-h-[740px] object-cover rounded-[28px] lg:rounded-[36px]"
          />

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-[16px] lg:gap-4">
            {advantages.map((item) => (
              <AdvantageCard key={item.title} {...item} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
